module.exports = __webpack_public_path__ + "images/admin/add-supershare-user-example.png";